import React from "react";
import FadedRightImage from "../common/FadedRightImage";
import HandshakeSvg from "../../Icons/HandshakeSvg";


export default function TopFadedServeciesImage() {
  return (
    <FadedRightImage
      title="We are here for you!"
      description="Only One step away from achieving your dreams!!! "
      image= {<HandshakeSvg/>}
    />
  );
}
